module.exports = __webpack_public_path__ + "e7a7eeb11a415fabd8b5a18611a2bdbd.fbx";